
export default class Login2024 {

    constructor() {
        this.init();
    }

    init() {
        if ($('.login2024-kont').length > 0) {
            $('.login2024-kont #login2form #jelszo').on('keyup', e => {
                if (e.keyCode == 13) {
                    $('.login2024-kont #login2form button').trigger('click')
                }
            });

            $('.login2024-kont #login2form button').on('click', e => {

                let email = $('.login2024-kont #login2form #email').val();
                let jelszo = $('.login2024-kont #login2form #jelszo').val();
                let hp = $('.login2024-kont #login2form #hp_website').val();

                let error = this.loginformcheck();

                if (!error) {
                    var formtoken = $('.login2024-kont #login2form input[name="formtoken"]').val();
                    $(e.currentTarget).addClass('wait4it');

                    $.post('/index.php/felhasznalok/loginservice/login', { email: email, kartyaszam: jelszo, formtoken: formtoken, forcelang: $('body').attr('data-aktlang'), hp_website: hp }, retlogin => {
                        if (retlogin.state == true) {
                            window.location.reload()
                        } else {
                            $(e.currentTarget).removeClass('wait4it');
                            $("div.errordiv").remove();
                            $(".errorredborder").removeClass("errorredborder");
                            $(".errordiv").text("");
                            if (!$(".errordiv").hasClass("hide")) {
                                $(".errordiv").addClass("hide");
                            }
                            let errorobj = { "str": retlogin.msg, "obj": ".login2024-kont #login2form #jelszo" };
                            this.drawError(errorobj)

                        }
                    }, 'json')
                }
            })

            $('.login2024-kont .extra-login.google-btn a').on('click', e => {
                e.preventDefault();
                if (typeof window.google_client_id !== 'undefined' && typeof google !== 'undefined' && google.accounts) {
                    const codeClient = google.accounts.oauth2.initCodeClient({
                        client_id: window.google_client_id,
                        scope: 'email profile',
                        ux_mode: 'redirect',
                        redirect_uri: window.google_redirect_uri,
                    });
                    codeClient.requestCode();
                } else {
                    window.location.href = $(e.currentTarget).attr('href') || '/';
                }
            })

            if (typeof window.apple_state !== 'undefined' || $('.login2024-kont .extra-login.apple-btn').length > 0) {
                this.apple_init();
            }

            if (typeof window.facebook_login_app_id != 'undefined') {
                this.fb_init();
            }

        }

        if (typeof window.google_showPopUp_window != "undefined") {
            this.google_showPopUp('/' + pageHandle + '?saveconnect=1&glogin=1');
        }

        if (typeof window.google_showPopUp_emptywindow != "undefined") {
            this.google_showPopUp('/' + pageHandle + '?emptypopoup=1');
        }
    }

    loginformcheck() {
        var error = false;
        var errorobj = [];

        if ($(".login2024-kont #login2form #email").val() == "") {
            error = true;
            errorobj.push({ "str": lngMessages["Email nem lehet üres"], "obj": ".login2024-kont #login2form #email" });
        } else {
            let emailReg = /^\S+@\S+\.\S+$/;
            if (!emailReg.test($(".login2024-kont #login2form #email").val())) {
                error = true;
                errorobj.push({ "str": lngMessages["Email cím nem tűnik érvényesnek"], "obj": ".login2024-kont #login2form #email" });
            }

        }

        if ($(".login2024-kont #login2form #jelszo").length > 0) {
            if ($(".login2024-kont #login2form #jelszo").val() == "") {
                error = true;
                errorobj.push({ "str": lngMessages["Jelszó kötelező"], "obj": ".login2024-kont #login2form #jelszo" });
            }

        }

        if ($(".login2024-kont #login2form #hp_website").length > 0 && $(".login2024-kont #login2form #hp_website").val() != "") {
            error = true;
            errorobj.push({ "str": lngMessages["Kötelező mező"], "obj": ".login2024-kont #login2form #email" });
        }

        if (error) {
            $("div.errordiv").remove();
            $(".errorredborder").removeClass("errorredborder");
            $(".errordiv").text("");
            if (!$(".errordiv").hasClass("hide")) {
                $(".errordiv").addClass("hide");
            }

            for (const eobj of errorobj) {
                this.drawError(eobj)
            }
        }

        return error;
    }

    drawError(eobj) {
        if ($(eobj.obj).length > 0) {
            if ($(eobj.obj).prop('tagName').toLowerCase() == "select") {
                $(eobj.obj).parents('.loginformrow').find(".fancy-select-display").addClass("errorredborder")
            } else {

                $(eobj.obj).addClass("errorredborder");

                var par = $(eobj.obj).parents('.loginformrow');
                if (par.length > 0) {
                    if (par.hasClass('checkbox')) {
                        $('<div>').addClass('errordiv hide').appendTo($(par).find('label'))
                    } else {
                        $('<div>').addClass('errordiv hide').appendTo($(par))
                    }
                }

                par.find(".errordiv").text(eobj.str).removeClass("hide")
            }
        }
    }

    fb_statusChangeCallback(response) {
        if (response.status === 'connected') {
            FB.api('/me', { fields: 'id, name, email, first_name, last_name' }, function (response) {

                response['method'] = 'check_login';
                $.post('/belepes/fb_login', response, function (res) {
                    document.location.reload(true);
                });
            });
        } else {
            console.log(response)
        }
    }


    fb_init() {

        window.fbAsyncInit = function () {

            FB.init({
                appId: window.facebook_login_app_id,
                cookie: true,
                version: 'v22.0'
            });


            // FB.getLoginStatus(function (response) {
            //     // belepes.fb_statusChangeCallback(response);
            // });

        };

        $('a#fblogout').on('click', e => {
            e.preventDefault()
            if (typeof FB === 'undefined') {
                return;
            }
            FB.logout(function (response) {

            });
        });

        $('.login2024-kont .extra-login.facebook-btn a').on('click', e => {
            e.preventDefault()
            const self = this;
            if (!e.currentTarget.hasAttribute('data-fbconnect')) {

                if (typeof FB === 'undefined') {
                    return;
                }

                e.currentTarget.setAttribute('data-fbconnect', '1');

                FB.login(function (response) {
                    if (response.status !== 'connected') {
                        e.currentTarget.removeAttribute('data-fbconnect');
                        return;
                    }
                    FB.api('/me', { fields: 'id, name, email, first_name, last_name' }, function (fbresp) {

                            if (typeof fbresp.email == 'string') {
                                let checkData = {
                                    'mode': 'fb',
                                    'email': fbresp.email,
                                    'id': fbresp.id,
                                    'token': $('#social-login-token').val()
                                };
                                $.get('/index.php/felhasznalok/loginservice/check_social_user_exists', checkData, function (stres) {
                                    if (stres.exists) {
                                        self.fb_showPopUp(fbresp)
                                    } else {
                                        fbresp['method'] = 'new_login';
                                        $.post('/' + pageHandle + '?step=2&fblogin=1', fbresp, function (res) {
                                            window.location.reload();
                                        });
                                    }
                                });
                            }
                        });
                }, { scope: 'public_profile,email' });
            }
        })
    }

    fb_showPopUp(fbresp) {
        var popWindowOverlay = $('<div>').addClass('pms-overlay');
        popWindowOverlay.appendTo($('body'))
        var popWindow = $('<div>').addClass('pop-window');
        var popClose = $('<a>').addClass('pop-closeme').attr('href', '');
        popClose.on('click', e => {
            e.preventDefault();
            $(e.currentTarget).parents('.pop-window').remove();
            $('.pms-overlay').remove();
        });
        popClose.appendTo(popWindow);
        var popBody = $('<div>').addClass('pop-body');

        var popBodyHead = $('<div>').addClass('body-head').text(lngMessages["Szeretné összekötni a fiókjait?"]);
        popBodyHead.appendTo(popBody);

        if ($('html').data('disztributor') != 'de') {
            var popBodyMessage = $('<div>').addClass('body-message').text(lngMessages['Úgy tűnik ezekkel az adatokkal már korábban létrehozott egy Pödör fiókot. Szeretné, hogy csatoljuk a felhasználót?']);
            popBodyMessage.appendTo(popBody);
        }

        var popBodyFooter = $('<div>').addClass('body-footer');

        var popConfirmButton = $('<a>').addClass('btn btn-default-white').attr('href', '').text(lngMessages["Igen, a fiókok összekötése"]);

        popConfirmButton.on('click', e => {
            e.preventDefault();

            fbresp['method'] = 'new_login';
            $.post('/' + pageHandle + '?step=2&fblogin=1', fbresp, function (res) {
                window.location.reload();
            });
        });
        popConfirmButton.appendTo(popBodyFooter);


        popBodyFooter.appendTo(popBody);

        popBody.appendTo(popWindow);

        popWindow.appendTo($('body'));

    }

    google_showPopUp(loginurl) {
        var popWindowOverlay = $('<div>').addClass('pms-overlay');
        popWindowOverlay.appendTo($('body'))
        var popWindow = $('<div>').addClass('pop-window');
        var popClose = $('<a>').addClass('pop-closeme').attr('href', '');
        popClose.on('click', e => {
            e.preventDefault();
            $(e.currentTarget).parents('.pop-window').remove();
            $('.pms-overlay').remove();
        });
        popClose.appendTo(popWindow);
        var popBody = $('<div>').addClass('pop-body');

        var popBodyHead = $('<div>').addClass('body-head').text(lngMessages["Szeretné összekötni a fiókjait?"]);
        popBodyHead.appendTo(popBody);

        if ($('html').data('disztributor') != 'de') {
            var popBodyMessage = $('<div>').addClass('body-message').text(lngMessages['Úgy tűnik ezekkel az adatokkal már korábban létrehozott egy Pödör fiókot. Szeretné, hogy csatoljuk a felhasználót?']);
            popBodyMessage.appendTo(popBody);
        }

        var popBodyFooter = $('<div>').addClass('body-footer');

        var popConfirmButton = $('<a>').addClass('btn btn-default-white').attr('href', loginurl).text(lngMessages["Igen, a fiókok összekötése"]);
        popConfirmButton.appendTo(popBodyFooter);


        popBodyFooter.appendTo(popBody);

        popBody.appendTo(popWindow);

        popWindow.appendTo($('body'));

    }
    apple_init() {
        const btn = $('.login2024-kont .extra-login.apple-btn a');
        const clientId = (typeof window.apple_client_id !== 'undefined' && window.apple_client_id) ? window.apple_client_id : btn.data('client-id');
        const redirectUri = (typeof window.apple_redirect_uri !== 'undefined' && window.apple_redirect_uri) ? window.apple_redirect_uri : (btn.data('redirect-uri') || '/apple-callback');
        const state = (typeof window.apple_state !== 'undefined' && window.apple_state) ? window.apple_state : btn.data('state');
        const nonce = (typeof window.apple_nonce !== 'undefined' && window.apple_nonce) ? window.apple_nonce : btn.data('nonce');
        const langCode = btn.data('lang') || 'hu_HU';

        if (!clientId || !state) {
            return;
        }

        const self = this;
        this.appleHandled = false;

        const initAuth = () => {
            if (typeof AppleID !== 'undefined' && AppleID.auth) {
                AppleID.auth.init({
                    clientId: clientId,
                    scope: 'name email',
                    redirectURI: redirectUri,
                    state: state,
                    nonce: nonce,
                    usePopup: true
                });
            }
        };

        document.addEventListener('AppleIDSignInOnSuccess', (event) => {
            const detail = (event && event.detail) ? event.detail : null;
            if (detail) {
                self.apple_handleSuccess(detail, redirectUri, state);
            }
        });

        document.addEventListener('AppleIDSignInOnFailure', (event) => {
            if (self.appleHandled) {
                return;
            }
            console.error('AppleIDSignInOnFailure esemény:', event);
            const errInfo = self.apple_parseError(event);
            self.apple_logError('AppleIDSignInOnFailure esemény', {
                error: errInfo.error,
                error_description: errInfo.error_description,
                raw: errInfo.raw
            }, state);
        });

        if (typeof AppleID !== 'undefined' && AppleID.auth) {
            initAuth();
        } else {
            const appleScript = document.createElement('script');
            appleScript.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/' + langCode + '/appleid.auth.js';
            appleScript.onload = () => {
                initAuth();
            };
            appleScript.onerror = (err) => {
                self.apple_logError('Apple JS SDK szkript betöltési hiba', { error: String(err) }, state);
            };
            document.head.appendChild(appleScript);
        }

        $('.login2024-kont .extra-login.apple-btn a').off('click').on('click', (e) => {
            e.preventDefault();
            const targetUrl = $(e.currentTarget).attr('href') || '/apple-login/start';
            const hasSdk = (typeof AppleID !== 'undefined' && !!AppleID.auth);

            if (hasSdk) {
                try {
                    const promise = AppleID.auth.signIn();
                    if (promise && typeof promise.then === 'function') {
                        promise.then((res) => {
                            if (res) {
                                self.apple_handleSuccess(res, redirectUri, state);
                            }
                        }).catch((err) => {
                            if (self.appleHandled) {
                                return;
                            }
                            console.error('AppleID signIn promise rejected:', err);
                            const errInfo = self.apple_parseError(err);
                            self.apple_logError('AppleID.auth.signIn promise rejected', {
                                error: errInfo.error,
                                error_description: errInfo.error_description,
                                raw: errInfo.raw
                            }, state);
                        });
                    }
                } catch (err) {
                    console.error('AppleID signIn hiba:', err);
                    const errInfo = self.apple_parseError(err);
                    self.apple_logError('AppleID.auth.signIn kivétel', {
                        error: errInfo.error,
                        raw: errInfo.raw
                    }, state);
                    window.location.href = targetUrl;
                }
            } else {
                window.location.href = targetUrl;
            }
        });
    }

    apple_logError(eventName, eventData, state) {
        try {
            $.ajax({
                url: '/apple-login/client-log',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({
                    event: eventName,
                    data: eventData || {},
                    type: 'error',
                    state: state || window.apple_state || null,
                    url: window.location.href
                })
            });
        } catch (e) {
            console.error('Apple log küldési hiba:', e);
        }
    }

    apple_parseError(evt) {
        const out = { error: null, error_description: null, raw: null };
        if (!evt) {
            out.error = 'empty_event';
            return out;
        }
        if (typeof evt === 'string') {
            out.error = evt;
            out.raw = evt;
            return out;
        }
        const detail = (evt && evt.detail !== undefined) ? evt.detail : evt;
        if (typeof detail === 'string') {
            out.error = detail;
            out.raw = detail;
            return out;
        }
        if (detail && typeof detail === 'object') {
            if (detail.error !== undefined) {
                if (typeof detail.error === 'string') {
                    out.error = detail.error;
                } else if (typeof detail.error === 'object' && detail.error !== null) {
                    out.error = detail.error.error || detail.error.message || null;
                    out.error_description = detail.error.error_description || detail.error.description || null;
                }
            }
            if (detail.error_description) {
                out.error_description = detail.error_description;
            }
            if (!out.error && detail.message) {
                out.error = detail.message;
            }
            try {
                out.raw = JSON.stringify(detail);
            } catch (e) {
                out.raw = String(detail);
            }
        } else {
            out.raw = String(detail);
        }
        if (!out.error && !out.error_description) {
            out.error = out.raw || 'ismeretlen_hiba';
        }
        return out;
    }

    apple_handleSuccess(data, redirectUri, state) {
        if (this.appleHandled) {
            return;
        }
        this.appleHandled = true;

        const auth = data ? (data.authorization || data) : null;
        if (!auth || (!auth.id_token && !auth.code)) {
            this.apple_logError('handleAppleSuccess: hianyzo token/kod', { data: data }, state);
            return;
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = redirectUri || window.apple_redirect_uri || '/apple-callback';

        const addInput = (name, val) => {
            if (val !== undefined && val !== null) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = (typeof val === 'object') ? JSON.stringify(val) : String(val);
                form.appendChild(input);
            }
        };

        addInput('state', auth.state || state || window.apple_state);
        addInput('code', auth.code || '');
        addInput('id_token', auth.id_token || '');
        const userObj = data.user || (auth && auth.user) || (data.detail && data.detail.user) || null;
        if (userObj) {
            addInput('user', userObj);
            try {
                const u = (typeof userObj === 'string') ? JSON.parse(userObj) : userObj;
                if (u && u.name) {
                    if (typeof u.name === 'object') {
                        if (u.name.firstName) addInput('first_name', u.name.firstName);
                        if (u.name.lastName) addInput('last_name', u.name.lastName);
                    } else if (typeof u.name === 'string') {
                        addInput('full_name', u.name);
                    }
                }
            } catch (e) {
                console.warn('Nem sikerult kinyerni a nevet a user objektumbol', e);
            }
        }

        addInput('apple_raw_data', (typeof data === 'object') ? JSON.stringify(data) : String(data));

        document.body.appendChild(form);
        form.submit();
    }
}

